<template>
	<v-list-group v-if="count" class="list-group">
		<template #activator>
			<v-list-item-content>
				<v-list-item-title class="section-title">
					{{ title }}
					<small>({{ count }})</small>
				</v-list-item-title>
			</v-list-item-content>
		</template>

		<v-divider />

		<v-list-item
			v-for="(value, name) in items"
			:key="name"
			class="list-item"
			:ripple="false"
			dense
			@click="$emit('click:list-item', { node, subpath: `${subpath}/${name}` })"
		>
			<slot v-bind="{ name, subpath: `${subpath}/${name}` }" />
		</v-list-item>
	</v-list-group>
</template>

<style lang="scss" scoped src="./PropList.scss"></style>

<script>
import _ from "lodash";

export default {
	props: {
		node: { type: Object, required: true },
		subpath: { type: String, required: true },
	},

	computed: {
		items() {
			return _.get(this.node, [...this.subpath.split("/")]);
		},

		title() {
			return _.startCase(this.subpath);
		},

		count() {
			return _.size(this.items);
		},
	},
};
</script>
